/* tslint:disable:max-line-length */
export const REDIRECT_DE = {
  // product
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/barbecue-bohnen':
    '/unser-gemuese/p/barbecue-bohnen/03083681031157',
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-champignons-in-scheiben':
    '/unser-gemuese/p/bio-champignons-in-scheiben/03083681093551',
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-erbsen-mit-m%C3%B6hrchen':
    '/unser-gemuese/p/bio-erbsen-mit-mohrchen/03083681013818',
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-goldmais%C2%AE':
    '/unser-gemuese/p/bio-goldmais/03083680977531',
  '/produkte-rezepte/suppen/champignon-suppe-mit-thymian':
    '/unser-gemuese/p/champignon-suppe/03083681081503',
  '/unser-gemuese/bio': 'unser-gemuese/bio-produkte',
  '/unser-gemuese/gemusebeute': '/unser-gemuese/pur-huelsenfruechte',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mono-salate/frischer-feldsalat':
    '/unser-gemuese/p/frischer-feldsalat/04000142016002',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mono-salate/feine-feldsalat-bl%C3%A4tter':
    '/unser-gemuese/p/feine-feldsalat-blatter/03083681069075',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/flair-der-provence':
    '/unser-gemuese/p/flair-der-provence/03083681089707',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/dressings/frisches-balsamico-dressing':
    '/unser-gemuese/p/frisches-balsamico-dressing/04000142016293',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/dressings/frisches-french-dressing':
    '/unser-gemuese/p/french-dressing/04000142016286',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/dressings/frisches-honig-senf-dressing':
    '/unser-gemuese/p/frisches-honig-senf-dressing/04042479101068',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/dressings/frisches-joghurt-dressing':
    '/unser-gemuese/p/frisches-joghurt-dressing/04000142016279',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/themen-salate/fr%C3%BChlings-salat':
    '/unser-gemuese/p/fruhlings-salat/03083681089424',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/garten-erbsen':
    '/unser-gemuese/p/garten-erbsen/03083680072618',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/garten-erbsen-mit-m%C3%B6hrchen':
    '/unser-gemuese/p/garten-erbsen-mit-mohrchen/03083680823647',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/garten-m%C3%B6hrchen':
    '/unser-gemuese/p/garten-mohrchen/03083681056570',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/garten-salat':
    '/unser-gemuese/p/garten-salat/04000142801653',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gem%C3%BCsemischung-holsteiner-art':
    '/unser-gemuese/p/holsteiner-art/03083680003070',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gem%C3%BCsemischung-leipziger-allerlei':
    '/unser-gemuese/p/leipziger-allerlei/03083680015363',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE':
    '/unser-gemuese/p/goldmais/03083680073608',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-bunter-mix':
    '/unser-gemuese/p/goldmais-bunter-mix/03083680685535',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-florida-mix':
    '/unser-gemuese/p/goldmais-florida-mix/03083680713696',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-junge-ernte':
    '/unser-gemuese/p/goldmais-junge-ernte/03083681034615',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-kentucky-mix':
    '/unser-gemuese/p/goldmais-kentucky-mix/03083680539500',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-mexiko-mix':
    '/unser-gemuese/p/goldmais-mexiko-mix/03083680019323',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-mit-chili':
    '/unser-gemuese/p/goldmais-mit-chili/03083681043815',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/goldmais%C2%AE-texas-mix':
    '/unser-gemuese/p/goldmais-texas-mix/03083680685542',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gr%C3%BCne-bohnen-zart-und-extra-fein':
    '/unser-gemuese/p/grune-bohnen-zart-und-extra-fein/03083680002219',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gr%C3%BCne-bohnen-zart-und-fein':
    '/unser-gemuese/p/grune-bohnen-zart-und-fein/03083680002561',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gr%C3%BCne-brechbohnen-fein':
    '/unser-gemuese/p/grune-brechbohnen-fein/03083680002165',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mischsalate-mit-rohkost/insalata-mix':
    '/unser-gemuese/p/insalata-mix-salat/03083681074079',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/junge-erbsen-zart-und-extra-fein':
    '/unser-gemuese/p/junge-erbsen-zart-und-extra-fein/03083680004053',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/junge-erbsen-zart-und-fein':
    '/unser-gemuese/p/junge-erbsen-zart-und-fein/03083680004657',
  '/produkte-rezepte/suppen/karotten-s%C3%BCsskartoffel-suppe':
    '/unser-gemuese/p/karotten-et-sukartoffel-suppe/03083681081411',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/kichererbsen':
    '/unser-gemuese/p/kichererbsen/03083681003949',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/kichererbsen-bohnen-mix':
    '/unser-gemuese/p/kichererbsen-bohnen-mix/03083681037388',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/kidney-bohnen':
    '/unser-gemuese/p/kidney-bohnen/03083680009508',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/rohkost/knackige-snack-karotten':
    '/unser-gemuese/p/knackige-snack-karotten/04000142016200',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/kreation':
    '/unser-gemuese/p/kreation/03083681089219',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gem%C3%BCse-klassiker-k%C3%BCrbis':
    '/unser-gemuese/p/kurbis/03083681080735',
  '/produkte-rezepte/suppen/k%C3%BCrbis-suppe':
    '/unser-gemuese/p/kurbis-suppe/03083681081473',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/linsen':
    '/unser-gemuese/p/linsen/03083680002752',
  '/produkte-rezepte/gem%C3%BCsekonserven/goldmais-co/maiskolben':
    '/unser-gemuese/p/maiskolben/03083680046374',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/mediterrane-bohnen':
    '/unser-gemuese/p/mediterrane-bohnen/03083680001793',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/mild-und-wild-xxl-pack':
    '/unser-gemuese/p/mild-et-wild-xxl/03083681098068',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/m%C3%B6hrchen-zart-und-extra-fein':
    '/unser-gemuese/p/mohrchen-zart-und-extra-fein/03083680000345',
  '/produkte-rezepte/suppen/paprika-tomaten-suppe':
    '/unser-gemuese/p/paprika-et-tomaten-suppe/03083681081442',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/raffinesse':
    '/unser-gemuese/p/raffinesse/03083681088755',
  '/produkte-rezepte/gem%C3%BCsekonserven/ratatouille':
    '/unser-gemuese/p/ratatouille/03083681009767',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gem%C3%BCse-klassiker-rote-bete':
    '/unser-gemuese/p/rote-bete-gewurfelt/03083681017656',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mono-salate/frischer-rucola':
    '/unser-gemuese/p/frischer-rucola/04000142016026',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/rucolatino':
    '/unser-gemuese/p/rucolatino/03083681088724',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/salat-bohnen-mix':
    '/unser-gemuese/p/salat-bohnen-mix/03083680912730',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mischsalate-mit-rohkost/salatino-mix':
    '/unser-gemuese/p/salatino-mix/03083681074352',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/themen-salate/sommer-salat':
    '/unser-gemuese/p/frischer-sommer-salat/04000142801974',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/gem%C3%BCse-klassiker-s%C3%BCsskartoffel':
    '/unser-gemuese/p/susskartoffel/03083681080667',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/texas-bohnen':
    '/unser-gemuese/p/texas-bohnen/03083680918015',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/tiger-bohnen':
    '/unser-gemuese/p/tiger-bohnen/03083681018264',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/wachsbrechbohnen':
    '/unser-gemuese/p/wachs-brechbohnen/03083680001854',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/weisse-bohnen':
    '/unser-gemuese/p/weisse-bohnen/03083680001663',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/wildkraeutersalat':
    '/unser-gemuese/p/wildkrauter-salat/03083681082883',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/themen-salate/winter-salat':
    '/unser-gemuese/p/winter-salat/04000142016538',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/salatschalen/protein-pause-salat-thunfisch':
    '/unser-gemuese/p/protein-pause-salat-thunfisch/03083681091052',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/salatschalen/deftige-auszeit-salat-schinken-Kaese':
    '/unser-gemuese/p/deftige-auszeit-salat-schinken-kase/03083681091199',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/salatschalen/urlaubsmoment-salat-patros-natur-linse':
    '/unser-gemuese/p/urlaubsmoment-salat-patros-linse/03083681091168',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/salatschalen/feierabend-laune-salat-caesar-art':
    '/unser-gemuese/p/feierabend-laune-salat-caesar/03083681091137',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/salatschalen/veggie-picknick-salat-vegetarische-frikadellen-mais':
    '/unser-gemuese/p/veggie-picknick-salat/03083681091021',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/salatschalen/sommerabend-salat-tomate-mozzarella':
    '/unser-gemuese/p/sommerabend-salat-tomate-mozzarella/03083681091250',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/themen-salate/herbst-salat':
    '/unser-gemuese/p/herbst-salat/03083681056457',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/themen-salate/oster-salat':
    '/unser-gemuese/p/oster-salat/04042479104151',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/protein-salat':
    '/unser-gemuese/p/protein-salat/03083681101188',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/kompositionen/kopfsalat-mit-gartenkraeutern':
    '/unser-gemuese/p/kopfsalat-mit-gartenkrautern/03083681090611',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mono-salate/junger-spinat':
    '/unser-gemuese/p/junger-spinat/03083681054958',

  // Recipe
  '/produkte-rezepte/rezepte/pumpkin-salat': '/rezept/r/kurbis-salat/de1f0001',
  '/produkte-rezepte/rezepte/wald-und-wiesen-salat':
    '/rezept/r/wald-und-wiesen-salat/de1f0003',
  '/produkte-rezepte/rezepte/schwarzw%C3%A4lder-feldsalat':
    '/rezept/r/schwarzwalder-feldsalat/de1f0004',
  '/produkte-rezepte/rezepte/knackiger-garten-salat':
    '/rezept/r/knackiger-garten-salat/de1f0005',
  '/produkte-rezepte/rezepte/caprese-mit-rucola':
    '/rezept/r/caprese-mit-rucola/de1f0006',
  '/produkte-rezepte/rezepte/rucolassini': '/rezept/r/rucolassini/de1f0007',
  '/produkte-rezepte/rezepte/fitness-salat': '/rezept/r/fitness-salat/de1f0008',
  '/produkte-rezepte/rezepte/fruchtiger-sommer-salat':
    '/rezept/r/fruchtiger-sommer-salat/de1f0009',
  '/produkte-rezepte/rezepte/herzhafter-winter-salat':
    '/rezept/r/herzhafter-winter-salat/de1f0010',
  '/produkte-rezepte/rezepte/salat-pizza': '/rezept/r/salat-pizza/de1f0011',
  '/produkte-rezepte/rezepte/salat-mediterran':
    '/rezept/r/salat-mediterran/de1f0012',
  '/produkte-rezepte/rezepte/lauwarmer-spinat-salat-mit-cranberrys-und-walnuss':
    '/rezept/r/lauwarmer-spinat-salat-mit-cranberrys-und-walnuss/de1f0019',
  '/produkte-rezepte/rezepte/orientalischer-spinatsalat':
    '/rezept/r/orientalischer-spinatsalat/de1f0020',
  '/produkte-rezepte/rezepte/linsensalat-mediterran':
    '/rezept/r/linsensalat-mediterran/de1c0022',
  '/produkte-rezepte/rezepte/salatteller-rhodos':
    '/rezept/r/salatteller-rhodos/de1c0023',
  '/produkte-rezepte/rezepte/knusprige-kartoffelpfanne':
    '/rezept/r/knusprige-kartoffelpfanne/de1c0024',
  '/produkte-rezepte/rezepte/gnocchi-pfanne':
    '/rezept/r/gnocchi-pfanne/de1c0025',
  '/produkte-rezepte/rezepte/gemuesekuchen-toscana':
    '/rezept/r/gemusekuchen-toscana/de1c0026',
  '/produkte-rezepte/rezepte/cremiges-risotto':
    '/rezept/r/cremiges-risotto/de1c0031',
  '/produkte-rezepte/rezepte/partysalat-mit-penne':
    '/rezept/r/partysalat-mit-penne/de1c0032',
  '/produkte-rezepte/rezepte/reisgericht-balkan':
    '/rezept/r/reisgericht-balkan/de1c0033',
  '/produkte-rezepte/rezepte/reissalat-mit-joghurt-knoblauchdressing':
    '/rezept/r/reissalat-mit-joghurt-knoblauchdressing/de1c0034',
  '/produkte-rezepte/rezepte/american-baked-potatoes':
    '/rezept/r/american-baked-potatoes/de1c0036',
  '/produkte-rezepte/rezepte/mediterraner-kartoffelsalat':
    '/rezept/r/mediterraner-kartoffelsalat/de1c0039',
  '/produkte-rezepte/rezepte/italienischer-bohnensalat':
    '/rezept/r/italienischer-bohnensalat/de1c0040',
  '/produkte-rezepte/rezepte/mediterraner-bohnensalat':
    '/rezept/r/mediterraner-bohnensalat/de1c0041',
  '/produkte-rezepte/rezepte/mais-bruschetta':
    '/rezept/r/mais-bruschetta/de1c0042',
  '/produkte-rezepte/rezepte/ofenkartoffel-mit-texas-dressing':
    '/rezept/r/ofenkartoffel-mit-texas-dressing/de1c0045',
  '/produkte-rezepte/rezepte/texas-ranger-pfanne':
    '/rezept/r/texas-ranger-pfanne/de1c0047',
  '/produkte-rezepte/rezepte/mexiko-pfanne': '/rezept/r/mexiko-pfanne/de1c0049',
  '/produkte-rezepte/rezepte/rustikale-pfanne':
    '/rezept/r/rustikale-pfanne/de1c0050',
  '/produkte-rezepte/rezepte/risotto-argentino':
    '/rezept/r/risotto-argentino/de1c0051',
  '/produkte-rezepte/rezepte/perlgraupensalat-mit-shrimps':
    '/rezept/r/perlgraupensalat-mit-shrimps/de1c0052',
  '/produkte-rezepte/rezepte/kichererbsen-couscous-salat':
    '/rezept/r/kichererbsen-couscous-salat/de1c0054',
  '/produkte-rezepte/rezepte/bunte-karotten-krustade':
    '/rezept/r/bunte-karotten-krustade/de1c0055',
  '/produkte-rezepte/rezepte/champignon-antipasti':
    '/rezept/r/champignon-antipasti/de1c0058',
  '/produkte-rezepte/rezepte/mais-tacos': '/rezept/r/mais-tacos/de1c0060',
  '/produkte-rezepte/rezepte/champignon-flammkuchen':
    '/rezept/r/champignon-flammkuchen/de1c0061',
  '/produkte-rezepte/rezepte/fruchtiger-rote-bete-salat':
    '/rezept/r/fruchtiger-rote-bete-salat/de1c0064',
  '/produkte-rezepte/rezepte/steaks-mit-champignon-nusstopping':
    '/rezept/r/steaks-mit-champignon-nusstopping/de1c0066',
  '/produkte-rezepte/rezepte/champignon-rotbarsch-pfanne':
    '/rezept/r/champignon-rotbarsch-pfanne/de1c0067',
  '/produkte-rezepte/rezepte/champignon-landbrot':
    '/rezept/r/champignon-landbrot/de1c0068',
  '/produkte-rezepte/rezepte/balsamico-champignons':
    '/rezept/r/balsamico-champignons/de1c0069',
  '/produkte-rezepte/rezepte/gnocchi-firenze':
    '/rezept/r/gnocchi-firenze/de1c0070',
  '/produkte-rezepte/rezepte/italienischer-bohnensalat-0':
    '/rezept/r/italienischer-bohnensalat/de1c0073',
  '/produkte-rezepte/rezepte/kichererbsen-joghurt-dip':
    '/rezept/r/kichererbsen-joghurt-dip/de1c0077',
  '/produkte-rezepte/rezepte/sizilianisches-linsenpesto-mit-spaghetti':
    '/rezept/r/sizilianisches-linsenpesto-mit-spaghetti/de1c0079',
  '/produkte-rezepte/rezepte/spanischer-bohnen-koriander-dip-mit-gebratenen-zucchini':
    '/rezept/r/spanischer-bohnen-koriander-dip-mit-gebratenen-zucchini/de1c0081',
  '/produkte-rezepte/rezepte/tomatensalat-mit-baked-beans':
    '/rezept/r/tomatensalat-mit-baked-beans/de1c0082',
  '/produkte-rezepte/rezepte/chili-mexiko-burger':
    '/rezept/r/chili-mexiko-burger/de1c0083',
  '/produkte-rezepte/rezepte/erbsencremesuppe':
    '/rezept/r/erbsencremesuppe/de1c0084',
  '/produkte-rezepte/rezepte/feurige-partysuppe':
    '/rezept/r/feurige-partysuppe/de1c0085',
  '/produkte-rezepte/rezepte/hackfleisch-bohnen-topf':
    '/rezept/r/hackfleisch-bohnen-topf/de1c0087',
  '/produkte-rezepte/rezepte/schweinegeschnetzeltes-curryrahm':
    '/rezept/r/schweinegeschnetzeltes-curryrahm/de1c0091',
  '/produkte-rezepte/rezepte/spaghetti-verdura':
    '/rezept/r/spaghetti-verdura/de1c0092',
  '/produkte-rezepte/rezepte/tagliatelle-mit-spinat':
    '/rezept/r/tagliatelle-mit-spinat/de1f0095',
  '/produkte-rezepte/rezepte/bohnen-speckmantel':
    '/rezept/r/bohnen-in-speckmantel/de1c0096',
  '/produkte-rezepte/rezepte/rote-bete-kekse':
    '/rezept/r/rote-bete-kekse/de1c0097',
  '/produkte-rezepte/rezepte/winter-salat-mit-leckerem-weihnachtsbalsamico-dressing':
    '/rezept/r/winter-salat-mit-leckerem-weihnachtsbalsamico-dressing/de1f0099',
  '/produkte-rezepte/rezepte/spinat-ananas-smoothie':
    '/rezept/r/spinat-ananas-smoothie/de1f0101',
  '/produkte-rezepte/rezepte/veganes-linsencurry':
    '/rezept/r/veganes-linsencurry/de1c0103',
  '/produkte-rezepte/rezepte/rotes-thai-curry':
    '/rezept/r/rotes-thai-curry/de1c0104',
  '/produkte-rezepte/rezepte/aprikosen-honig-dressing':
    '/rezept/r/aprikosen-honig-dressing/de1f0106',
  '/produkte-rezepte/rezepte/sommersalat-mit-linsen':
    '/rezept/r/sommersalat-mit-linsen/de1f0109',
  '/produkte-rezepte/rezepte/salat-capricciosa-mit-cocktail-dressing-0':
    '/rezept/r/salat-capricciosa-mit-cocktail-dressing/de1f0110',
  '/produkte-rezepte/rezepte/rucolatino-salat-mit-gegrilltem-halloumi-und-himbeerdressing':
    '/rezept/r/rucolatino-salat-mit-gegrilltem-halloumi-und-himbeerdressing/de1f0111',
  '/produkte-rezepte/rezepte/rucola-brotsalat-mit-tomatendressing':
    '/rezept/r/rucola-brotsalat-mit-tomatendressing/de1f0112',
  '/produkte-rezepte/rezepte/feldsalat-mit-nudeln-feldsalat-pesto-und-baconchips':
    '/rezept/r/feldsalat-mit-nudeln-feldsalat-pesto-und-baconchips/de1f0113',
  '/produkte-rezepte/rezepte/bohnenpfanne-vom-grill':
    '/rezept/r/bohnenpfanne-vom-grill/de1c0114',
  '/produkte-rezepte/rezepte/bunter-tortellini-salat':
    '/rezept/r/bunter-tortellini-salat/de1c0115',
  '/produkte-rezepte/rezepte/garnelen-champignon-mix-vom-grill':
    '/rezept/r/garnelen-champignon-mix-vom-grill/de1c0116',
  '/produkte-rezepte/rezepte/goldmais-frikadellen':
    '/rezept/r/goldmais-frikadellen/de1c0117',
  '/produkte-rezepte/rezepte/mexiko-quinoa-salat':
    '/rezept/r/mexiko-quinoa-salat/de1c0118',
  '/produkte-rezepte/rezepte/klassisches-chili-con-carne':
    '/rezept/r/klassisches-chili-con-carne/de1c0124',
  '/produkte-rezepte/rezepte/vegetarische-wraps':
    '/rezept/r/vegetarische-wraps/de1c0123',
  '/produkte-rezepte/rezepte/hummus': '/rezept/r/hummus/de1c0126',
  '/produkte-rezepte/rezepte/ratatouille_crostini_mit_gratiniertem_ziegenkaese':
    '/rezept/r/ratatouille-crostini-mit-gratiniertem-ziegenkase/de1c0128',
  // artikel
  '/qualit%C3%A4t-ern%C3%A4hrung/unsere-salat-bauern':
    '/ueber-uns/artikel/unsere-salat-bauern/439/439',
  '/unternehmen-nachhaltigkeit/nachhaltigkeit':
    '/ueber-uns/artikel/bestes-gemuese-aus-verantwortungsbewusstem-anbau/589/589',

  // 13/09/19
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-gr%C3%BCne-bohnen': '/unser-gemuese/p/bio-grune-bohnen/03083681013795',
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-junge-erbsen': '/unser-gemuese/p/bio-junge-erbsen/03083681013832',
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-kichererbsen': '/unser-gemuese/p/bio-kichererbsen/03083681052848',
  '/produkte-rezepte/gem%C3%BCsekonserven/bio/bio-kidneybohnen': '/unser-gemuese/p/bio-kidney-bohnen/03083681052831',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/bohnen-duo': '/unser-gemuese/p/bohnen-duo/03083681037357',
  '/produkte-rezepte/gem%C3%BCsekonserven/bunt-dazu-®/bunt-dazu®-goldmais®': '/unser-gemuese/p/bunt-dazu-goldmais/03083681068184',
  '/produkte-rezepte/gem%C3%BCsekonserven/bunt-dazu-®/bunt-dazu®-kichererbsen': '/unser-gemuese/p/bunt-dazu-kichererbsen/03083681068146',
  '/produkte-rezepte/gem%C3%BCsekonserven/bunt-dazu-®/bunt-dazu®-kidney-bohnen': '/unser-gemuese/p/bunt-dazu-kidneybohnen/03083681068122',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/bunter-karotten-mix': '/unser-gemuese/p/bunter-karotten-mix/03083680917988',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-ganze-k%C3%B6pfe-1wahl': '/unser-gemuese/p/champignons-ganze-kopfe-1.wahl/03083680010061',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-ganze-k%C3%B6pfe-1wahl-0': '/unser-gemuese/p/champignons-ganze-kopfe-1.wahl-im-glas/03083681007640',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-ganze-k%C3%B6pfe-mit-dill-eingelegt': '/unser-gemuese/p/champignons-ganze-kopfe-eingelegt-in-dill/03083681021110',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-minis-1wahl': '/unser-gemuese/p/champignons-minis-1.wahl/03083680975353',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-scheiben-1wahl': '/unser-gemuese/p/champignons-scheiben-1.wahl/03083680019873',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-scheiben-2wahl': '/unser-gemuese/p/champignons-scheiben-2.wahl/03083681009835',
  '/produkte-rezepte/gem%C3%BCsekonserven/champignons/champignons-scheiben-2wahl-0': '/unser-gemuese/p/champignons-scheiben-2.wahl-im-glas/03083681007657',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/chili-bohnen': '/unser-gemuese/p/chili-bohnen/03083681075847',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mischsalate-mit-rohkost/country-mix': '/unser-gemuese/p/country-mix/04000142016767',
  '/produkte-rezepte/gem%C3%BCsekonserven/h%C3%BClsenfr%C3%BCchte/curry-bohnen': '/unser-gemuese/p/curry-bohnen/03083681031171',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/erbsen-mit-m%C3%B6hrchen-zart-und-extra-fein': '/unser-gemuese/p/erbsen-mit-mohrchen-zart-und-extra-fein/03083680003421',
  '/produkte-rezepte/gem%C3%BCsekonserven/zartgem%C3%BCse/erbsen-mit-m%C3%B6hrchen-zart-und-fein': '/unser-gemuese/p/erbsen-mit-mohrchen-zart-und-fein/03083680003841',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mischsalate-mit-rohkost/family-mix': '/unser-gemuese/p/family-mix/03083681074017',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/rohkost/feine-karottenstifte': '/unser-gemuese/p/feine-karottenstifte/04000142016170',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/themen-salate/frischer-festtags-salat': '/unser-gemuese/p/festtags-salat/04042479104083',
  '/produkte-rezepte/rezepte/raffinesse-mit-ger%C3%A4ucherter-forelle-apfel-und-roter-bete-meerrettich-creme': '/rezept/r/raffinesse-mit-geraucherter-forelle-apfel-und-roter-bete-meerrettich-creme/de1f0013',
  '/produkte-rezepte/rezepte/country-salat-im-filo-k%C3%B6rbchen': '/rezept/r/country-salat-im-filo-korbchen/de1f0014',
  '/produkte-rezepte/rezepte/fr%C3%BChlings-salat-mit-spargel-schinken-taschen': '/rezept/r/fruhlings-salat-mit-spargel-schinken-taschen/de1f0016',
  '/produkte-rezepte/rezepte/herbst-salat-mit-k%C3%BCrbis-apfel-puffer': '/rezept/r/herbst-salat-mit-kurbis-apfel-puffer/de1f0017',
  '/produkte-rezepte/rezepte/oster-salat-mit-lamm-aprikosen-spießen': '/rezept/r/oster-salat-mit-lamm-aprikosen-spiessen/de1f0021',
  '/produkte-rezepte/rezepte/gefl%C3%BCgelragout': '/rezept/r/geflugelragout/de1c0027',
  '/produkte-rezepte/rezepte/rinderfiletstreifen-k%C3%A4sesauce': '/rezept/r/rinderfiletstreifen-in-kasesauce/de1c0028',
  '/produkte-rezepte/rezepte/indisches-h%C3%BChnchen-curry': '/rezept/r/indisches-huhnchen-curry/de1c0029',
  '/produkte-rezepte/rezepte/bandnudeln-mit-r%C3%A4ucherlachs': '/rezept/r/bandnudeln-mit-raucherlachs/de1c0030',
  '/produkte-rezepte/rezepte/bunte-grillspieße': '/rezept/r/bunte-grillspiesse/de1c0035',
  '/produkte-rezepte/rezepte/%C3%BCberbackene-tortillas': '/rezept/r/uberbackene-tortillas/de1c0037',
  '/produkte-rezepte/rezepte/%C3%BCberbackene-tortillachips': '/rezept/r/uberbackene-tortillachips/de1c0038',
  '/produkte-rezepte/rezepte/mit-mais-avocadocreme-gef%C3%BCllte-tomaten': '/rezept/r/mit-mais-avocadocreme-gefullte-tomaten/de1c0043',
  '/produkte-rezepte/rezepte/tomatensuppe-provençal': '/rezept/r/tomatensuppe-provencal/de1c0044',
  '/produkte-rezepte/rezepte/gem%C3%BCsetortilla-mit-petersilienschmand': '/rezept/r/gemusetortilla-mit-petersilienschmand/de1c0046',
  '/produkte-rezepte/rezepte/goldene-lachsp%C3%A4ckchen': '/rezept/r/goldene-lachspackchen/de1c0048',
  '/produkte-rezepte/rezepte/mediterraner-bohnensalat-mit-schafsk%C3%A4se': '/rezept/r/mediterraner-bohnensalat-mit-schafskase/de1c0053',
  '/produkte-rezepte/rezepte/w%C3%BCrzige-lauch-pilz-quiche': '/rezept/r/wurzige-lauch-pilz-quiche/de1c0056',
  '/produkte-rezepte/rezepte/filet-vom-grill-mit-texasf%C3%BCllung': '/rezept/r/filet-vom-grill-mit-texasfullung/de1c0057',
  '/produkte-rezepte/rezepte/goldmais-®-quiche': '/rezept/r/goldmais-quiche/de1c0059',
  '/produkte-rezepte/rezepte/pangasiusfilet-mit-champignon-kr%C3%A4uter-topping': '/rezept/r/pangasiusfilet-mit-champignon-krauter-topping/de1c0062',
  '/produkte-rezepte/rezepte/mexiko-bl%C3%A4tterteigtaschen': '/rezept/r/mexiko-blatterteigtaschen/de1c0063',
  '/produkte-rezepte/rezepte/champignon-ragout-mit-semmelkn%C3%B6del': '/rezept/r/champignon-ragout-mit-semmelknodel/de1c0065',
  '/produkte-rezepte/rezepte/mango-salat-mit-h%C3%A4hnchenstreifen': '/rezept/r/mango-salat-mit-hahnchenstreifen/de1c0071',
  '/produkte-rezepte/rezepte/marokkanische-gem%C3%BCsepfanne': '/rezept/r/marokkanische-gemusepfanne/de1c0072',
  '/produkte-rezepte/rezepte/t%C3%BCrkischer-bohnensalat': '/rezept/r/turkischer-bohnensalat/de1c0074',
  '/produkte-rezepte/rezepte/%C3%BCberbackene-tortillachips-%C3%A0-la-mexiko': '/rezept/r/uberbackene-tortillachips-a-la-mexiko/de1c0075',
  '/produkte-rezepte/rezepte/kichererbsen-gem%C3%BCse-curry': '/rezept/r/kichererbsen-gemuse-curry/de1c0076',
  '/produkte-rezepte/rezepte/asia-curry-h%C3%BChnchen-mit-linsen': '/rezept/r/asia-curry-huhnchen-mit-linsen/de1c0078',
  '/produkte-rezepte/rezepte/franz%C3%B6sischer-bohnentopf': '/rezept/r/franzosischer-bohnentopf/de1c0080',
  '/produkte-rezepte/rezepte/gef%C3%BCllte-champignons': '/rezept/r/gefullte-champignons/de1c0086',
  '/produkte-rezepte/rezepte/kartoffelsalat-%C3%A0-la-maison': '/rezept/r/kartoffelsalat-a-la-maison/de1c0088',
  '/produkte-rezepte/rezepte/saftige-grillsteaks-mit-pfeffrigem-gem%C3%BCse': '/rezept/r/saftige-grillsteaks-mit-pfeffrigem-gemuse/de1c0090',
  '/produkte-rezepte/rezepte/kr%C3%A4uter-pistazien-falafel': '/rezept/r/krauter-pistazien-falafel/de1c0094',
  '/produkte-rezepte/rezepte/gr%C3%BCnes-erbseneis-mit-kokos-und-pistazien': '/rezept/r/grunes-erbseneis-mit-kokos-und-pistazien/de1c0098',
  '/produkte-rezepte/rezepte/spinatkn%C3%B6del': '/rezept/r/spinatknodel/de1f0100',
  '/produkte-rezepte/rezepte/h%C3%A4hnchenpfanne-mit-gartengem%C3%BCse': '/rezept/r/hahnchenpfanne-mit-gartengemuse/de1c0102',
  '/produkte-rezepte/rezepte/m%C3%B6hren-bohnen-kartoffelgratin': '/rezept/r/mohren-bohnen-kartoffelgratin/de1c0105',
  '/produkte-rezepte/rezepte/m%C3%B6hren-hummus-mit-gegrillten-gem%C3%BCsesticks': '/rezept/r/mohren-hummus-mit-gegrillten-gemusesticks/de1c0119',
  '/produkte-rezepte/rezepte/ziegenk%C3%A4se-vom-grill-auf-goldmais-kr%C3%A4uterbett': '/rezept/r/ziegenkase-vom-grill-auf-goldmais-krauterbett/de1c0120',
  '/produkte-rezepte/rezepte/tigerbohnen-s%C3%BCßkartoffel-eintopf-mit-reis': '/rezept/r/tigerbohnen-susskartoffel-eintopf-mit-reis/de1c0121',
  '/produkte-rezepte/rezepte/curry-pasta-mit-bohnen-gem%C3%BCse': '/rezept/r/curry-pasta-mit-bohnen-et-gemuse/de1c0122',
  '/produkte-rezepte/rezepte/gr%C3%BCner-salat-mit-goldmais®': '/rezept/r/gruner-salat-mit-goldmais/de1f0125',
  '/produkte-rezepte/rezepte/gr%C3%BCne-bohnenpfanne': '/rezept/r/grune-bohnenpfanne/de1c0127',
  '/ueber-uns/artikel/unsere-salat-bauern/439/439,': '/ueber-uns/artikel/unsere-salat-bauern/439/439',
  '/ueber-uns/artikel/ein-tag-als-vegetarier/483/483,': '/ueber-uns/artikel/ein-tag-als-vegetarier/483/483',
  '/unternehmen-nachhaltigkeit/bonduelle-als-arbeitgeber': '/karriere',
  '/produkte-rezepte/frische-salate-gem%C3%BCse/mischsalate-mit-rohkost/salat-von-unseren-bauern': '/unser-gemuese/p/salat-von-unseren-bauern/03083681104608',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/aubergine': '/ueber-uns/vom-feld-auf-den-teller/die-aubergine-ein-gesundes-und-vielfaeltiges-fruchtgemuese/252/158',
  '/produkte-rezepte/rezepte/kuerbis-schupfnudeln-mit-champignons': '/',
  '/produkte-rezepte/rezepte/linsensalat-%C2%84mediterran%C2%93': '/rezept/r/linsensalat-mediterran/de1c0022',
  '/produkte-rezepte/rezepte/vegetarische-quesadilla': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/wei%C3%9Fkohl': '/ueber-uns/vom-feld-auf-den-teller/der-kohl-alles-was-sie-wissen-muessen/431/98',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/wei%C3%9Fe-bohnen': '/ueber-uns/vom-feld-auf-den-teller/bohnen-ein-gemuese-mit-vielen-vorteilen-fuer-unsere-gesundheit/425/104',
  '/produkte-rezepte/rezepte/sommerrollen': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/schwarzwurzel': '/ueber-uns/vom-feld-auf-den-teller/schwarzwurzeln-ein-zu-unrecht-vergessenes-gemuese/269/157',
  '/produkte-rezepte/rezepte': '/rezepte',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/radicchio': '/',
  '/produkte-rezepte/rezepte/one-pot-pasta-mit-bunt-dazu-kichererbsen': '/',
  '/produkte-rezepte/rezepte/rote_bete_suppe_mit_kartoffelchips': '/',
  '/https%3A//www.bonduelle.de/produkte-rezepte/rezepte/farfalle-mit-champignon-sahneso%C3%9Fe': '/',
  '/produkte-rezepte/rezepte/lachsnudeln-mit-erbsen-und-babyspinat': '/',
  '/produkte-rezepte/rezepte/farfalle-mit-champignon-sahneso%C3%9Fe': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/eisbergsalat': '/ueber-uns/vom-feld-auf-den-teller/der-eisberg-perfekt-fuer-sandwiches-und-wraps/254/163',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/knollensellerie': '/ueber-uns/vom-feld-auf-den-teller/der-sellerie-ein-starker-verbuendeter-beim-schlankwerden/258/159',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/endivie': '/',
  '/aktionen/traditionelle_gemuesesorten': '/',
  '/produkte-rezepte/rezepte/gr%C3%BCner-salat-mit-goldmais%C2%AE': '/rezept/r/gruner-salat-mit-goldmais/de1f0125',
  '/produkte-rezepte/rezepte/gemuesebratlinge_mit_mais_und_kraeuterdip': '/',
  '/produkte-rezepte/rezepte/koettbullar-mit-champignon-rahmsauce': '/',
  '/sites/default/files/downloads/Pressetext_Bonduelle_Sommersalate.pdf': '/',
  '/produkte-rezepte/rezepte/knusprige-kuerbis-curry-lasagne': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/lollo-bionda': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/ern%C3%A4hrung/allergene': '/',
  '/taxonomy/term/48': '/',
  '/produkte-rezepte/rezepte/pumpkin_spice_latte': '/rezept/r/pumpkin-spice-latte/de1c0111',
  '/aktuelles-aktionen/wild-auf-wiese	http://wildaufwiese.bonduelle.de/': '/',
  '/produkte-rezepte/rezepte/geschmorte-lammhaxe-mit-rote-bete-polenta-talern': '/',
  '/produkte-rezepte/gem%C3%BCsekonserven/bunt-dazu-%C2%AE/bunt-dazu%C2%AE-goldmais%C2%AE': '/unser-gemuese/p/bunt-dazu-goldmais/03083681068184',
  '/produkte-rezepte/rezepte/rote-bete-risotto': '/',
  '/produkte-rezepte/rezepte/rucola-erdbeer-spargel-salat': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/anbau': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/limabohnen': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/wachtelbohnen': '/',
  '/produkte-rezepte/rezepte/kleine-tartelettes-mit-ratatouille': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/roter-mangold': '/',
  '/produkte-rezepte/gem%C3%BCsekonserven/bunt-dazu-%C2%AE/bunt-dazu%C2%AE-kichererbsen': '/unser-gemuese/p/bunt-dazu-kichererbsen/03083681068146',
  '/qualit%C3%A4t-ern%C3%A4hrung/verarbeitung': '/',
  '/produkte-rezepte/frische-salate-gem%C3%BCse': '/unser-gemuese',
  '/produkte-rezepte/rezepte/goldener-oktober-salat': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/fris%C3%A9e': '/ueber-uns/vom-feld-auf-den-teller',
  '/produkte-rezepte/rezepte/champignon_risotto': '/',
  '/produkte-rezepte/rezepte/antipasti-salat': '/rezept/r/champignon-antipasti/de1c0058',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/schnittlauch': '/',
  '/produkte-rezepte/rezepte/veganer_kichererbsen-cheesecake_mit_salzkaramell': '/rezept/r/veganer-kichererbsen-cheesecake-mit-salzkaramell/de1c0101',
  '/qualit%C3%A4t-ern%C3%A4hrung/kontroll-qualit%C3%A4tsstandards': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/augenbohnen-schwarzaugenbohnen-bonduelle-tigerbohnen': '/',
  '/produkte-rezepte/jahr-der-h%C3%BClsenfrucht': '/',
  '/sites/default/files/Bonduelle_Suppe.pdf': '/',
  '/produkte-rezepte/rezepte/rosenkohl-suesskartoffel-pfanne': '/',
  '/produkte-rezepte/rezepte/tigerbohnen-s%C3%BC%C3%9Fkartoffel-eintopf-mit-reis': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/mesclun': '/',
  '/aktuelles-aktionen/tv-spots': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/zwiebelnschalotten': '/ueber-uns/vom-feld-auf-den-teller/die-zwiebel-ein-kleines-vielfaeltiges-gesundheitswunder/253/149',
  '/sites/default/files/downloads/180410_Presseinformation_Bonduelle_WM.pdf': '/',
  '/produkte-rezepte/rezepte/zweierlei_suesskartoffel_mit_popcorn_und_vanilleeis': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/kopfsalat': '/',
  '/produkte-rezepte/rezepte/pasta_mit_kuerbis_jungem_spinat_zitrone_und_parmesan': '/',
  '/produkte-rezepte/rezepte/rote-bete-hummus': '/',
  '/qualit%C3%A4t-ern%C3%A4hrung/warenkunde/kichererbsen': '/ueber-uns/vom-feld-auf-den-teller/kichererbsen-eine-vielseitige-und-koestliche-proteinquelle/265/156',
  '/produkte-rezepte/rezepte/suesskartoffel-quesadilla-mit-rinderhackfleisch': '/',
  '/produkte-rezepte/rezepte/gegrillte-wassermelone-mit-feta-und-rucola': '/',
  '/produkte-rezepte/rezepte/goldmais-%C2%AE-quiche': '/rezept/r/goldmais-quiche/de1c0059',
  // redirection 27/01/20
  '/unser-gemuese/p/goldmais/03083680073608': '/unser-gemuese/p/goldmais/03083681102499',
  '/produkte-rezepte/rezepte/regenbogen-lasagne': '/rezept/r/regenbogen-lasagne/de1c0110',
  '/produkte-rezepte/rezepte/glutenfreie-kidneybohnen-brownies': '/rezept/r/kidneybohnen-brownies-glutenfrei/de1c0131',
  '/produkte-rezepte/rezepte/karottenkuchen': '/rezept/r/karottenkuchen/de1c0130',
  '/produkte-rezepte/rezepte/kidneybohnen-burger': '/rezept/r/veggie-burger-mit-kidney-bohnen/de1c0113',
  '/produkte-rezepte/ein-tag-ohne': '/ueber-uns/artikel/ein-tag-als-vegetarier/483/483',
  '/produkte-rezepte/rezepte/mexikanischer-gem%C3%BCsewrap-0': '/rezept/r/mexikanischer-wrap/de1c0100',
  '/produkte-rezepte/rezepte/sommersalat-mit-huehnerbrust-erdbeeren-und-avocado':
    '/rezept/r/sommersalat-mit-huhnerbrust-erdbeeren-und-avocado/de1c0109',
  '/produkte-rezepte/rezepte/tex-mex-grill-salat': '/rezept/r/tex-mex-grill-salat/de1c0107',
  '/produkte-rezepte/rezepte/lachs-bohnen-p%C3%A4ckchen-vom-grill': '/rezept/r/lachs-bohnen-packchen-vom-grill/de1c0108',
  '/produkte-rezepte/rezepte/geroestete-kichererbsen': '/rezept/r/gerostete-kichererbsen/de1c0112',
  '/produkte-rezepte/rezepte/salat_von_linsen_und_roter_bete_mit_karamellisiertem_ziegenkaese_und_wildkraeutern':
    '/rezept/r/salat-von-linsen-mit-rote-bete-und-wildkrauter-salat-von-sebastian-franke/de1c0129',
  '/produkte-rezepte/rezepte/kichererbsen-kekse': '/rezept/r/kichererbsen-kekse/de1c0132',
  '/produkte-rezepte/rezepte/kuerbis-pancakes': '/rezept/r/kurbis-pancakes/de1c0133',
  '/nachhaltiger-anbau': '/ueber-uns/artikel/wir-verpflichten-uns-zu-nachhaltigem-anbau/2272/2272',
  '/cabaletta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/caballetta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/caballeta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/cabaleta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/kabaletta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/kaballetta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/kaballeta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/kabaleta': '/ueber-uns/artikel/cabaletta-die-salatbar-neu-erfunden/2380/2380',
  '/gemuese4me': '/gemuese4me/aktuelles',
  '/gemuse4me': '/gemuese4me/aktuelles',
  '/gemüse4me': '/gemuese4me/aktuelles'
};
